

export const LEAD_UPDATED_EVENT = 'lead_updated';
export const LEAD_CREATED_EVENT = 'lead_created';
export const SERVICE_REQUEST_SAVED = 'service_request_saved';
export const SERVICE_REQUEST_ACTION = 'service_request_action';
export const SERVICE_REQUEST_UPDATED = 'service_request_updated';

export const CALENDAR_EVENT_SAVED = 'calendar_event_saved';
export const CALENDAR_EVENT_DELETED = 'calendar_event_deleted';

// Recurring series lifecycle (WebsocketService::EVENT_RECURRING_* in conversional-laravel).
// Payload only carries the series' uuid + start/end bounds, not per-occurrence data — a
// series create/edit/delete can touch up to 366 rows, so there's nothing to patch a single
// event with. The calendar board refetches instead (see PusherWebsocketSubscriber).
export const RECURRING_CREATED = 'recurring_created';
export const RECURRING_UPDATED = 'recurring_updated';
export const RECURRING_DELETED = 'recurring_deleted';

export const BACKOFFICE_SERVICE_REQUEST_ACTION = 'backoffice_service_request_created';

export const REFRESH_LEADS = 'refresh_leads';

export const UPDATE_LEAD_IF_DRAWER_OPEN = 'update_lead_if_drawer_open';

export const FETCH_ME = 'fetch_me';

// Internal-only (no Pusher bind): an agent was added to / removed from a branch
// service, in the branch service drawer or in the user drawer. The calendar builds
// its columns from `branch.services[].agents`, so DvaWatcher refetches the touched
// branches into the store no matter which page is open.
export const SERVICE_AGENTS_CHANGED = 'service_agents_changed';

// Internal-only (no Pusher bind): an appointment was cancelled/confirmed/declined or
// deleted. The team-view calendar and an open lead drawer both show it, and neither is
// necessarily the surface the action was taken on — each has its own subscriber.
export const APPOINTMENT_CHANGED = 'appointment_changed';

export type AppointmentChangedPayload = {
  appointmentId?: string;
  // Absent for appointments with no lead (custom calendar events).
  leadId?: string;
};

export type ServiceAgentsChangedPayload = {
  // Known branch ids (branch service drawer). Optional: the user drawer only knows
  // the service, so the branch is resolved from the store.
  branchIds?: (string | undefined)[];
  serviceIds?: (string | undefined)[];
};

export const EXPORT_READY = 'export_ready';

export const OPEN_HELP_CENTER = 'open_help_center';
